module.exports = __webpack_public_path__ + "static/media/phone.50240718.svg";